import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function FuturePacing() {
  return <section className="w-full bg-gradient-to-b from-[#1a2c42] to-[#0F1B2D] text-[#FAFAF5] py-24 px-6 md:px-12" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center" data-id="element-76">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-bold mb-12" data-id="element-77">
          Imagine this a week from now
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0F1B2D]/50 border border-gray-700 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-78">
          <p className="text-xl text-gray-300 mb-8" data-id="element-79">
            You're not asking, "What should I do?"{' '}
            <span className="text-white font-bold" data-id="element-80">You're doing it.</span>
          </p>

          <ul className="text-left space-y-4 max-w-lg mx-auto mb-12" data-id="element-81">
            {['4 real samples ready to show', 'A portfolio you can send in 10 seconds', "A message script you don't have to reinvent", "A tracker showing you exactly how many reps you've done"].map((item, i) => <li key={i} className="flex items-center gap-4 text-lg md:text-xl" data-id="element-82">
                <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0" data-id="element-83">
                  <Check className="w-4 h-4 text-green-500" data-id="element-84" />
                </div>
                <span data-id="element-85">{item}</span>
              </li>)}
          </ul>

          <p className="text-2xl font-bold text-[#E8722A] mb-8" data-id="element-86">
            That's what creates replies. Not wishful thinking.
          </p>

          <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-[#E8722A] hover:bg-[#F59E0B] text-white font-bold text-lg px-8 py-4 rounded-full transition-all shadow-[0_0_20px_rgba(232,114,42,0.3)] hover:shadow-[0_0_30px_rgba(232,114,42,0.5)] transform hover:-translate-y-1" data-id="element-87">
            Get the UGC Starter Kit <ArrowRight className="w-5 h-5" data-id="element-88" />
          </a>
        </motion.div>
      </div>
    </section>;
}